import React, { useState } from 'react';
import Text from 'components/Core/Text';
import ToggleSwitchContainer from './styles';

const ToggleSwitch = ({
  indexSelected,
  titles,
  handleClick,
  selectedColor = 'var(--titan-blue-3)',
  theme,
}) => {
  const [open, toggleOpen] = useState(false);
  const [animate, toggleAnimate] = useState(false);
  const twoItemToggle = titles?.length === 2;

  const handleOpenClick = () => {
    toggleAnimate(true);

    setTimeout(() => {
      toggleAnimate(false);
      toggleOpen(false);
    }, 600);
  };

  const handleToggleClick = (index) => {
    if (open) {
      handleOpenClick();
    } else {
      toggleOpen(true);
    }
    handleClick(index);
  };

  return (
    <ToggleSwitchContainer
      className={`toggle--switch active-${indexSelected} ${!twoItemToggle ? 'over-two' : ''} ${
        !twoItemToggle && open ? 'open' : 'closed'
      } ${animate ? 'animate' : ''}  ${theme === 'Dark' ? 'dark' : 'light'}`}
      twoItemToggle={twoItemToggle}
    >
      <div className="toggle-switch--group">
        <div className="toggle--titles">
          {(titles || []).map((title, index) => {
            const selected = index === indexSelected;
            const color = index === indexSelected ? selectedColor : 'var(--grey-8)';

            return (
              <button
                type="button"
                className={`toggle--title-container${selected ? ' selected' : ' inactive'}`}
                key={`toggle--title-container-${index}`}
                onClick={() => handleToggleClick(index)}
                aria-pressed={selected}
              >
                <Text type="p" size="normal" className="toggle--title" color={color}>
                  {title}
                </Text>
              </button>
            );
          })}
        </div>
        <div className="toggle--toggle" />
      </div>
    </ToggleSwitchContainer>
  );
};

export default ToggleSwitch;
